import { makeStyles } from '@material-ui/core/styles';
import { btMediumGrayColor } from '../../../assets/jss/nextjs-material-kit-pro';

const useCareerInterestStyles = makeStyles((theme) => ({
  box: {
    padding: '25px',
    paddingBottom: '15px',
  },
  interest1: {
    marginBottom: 25,
    '@media print': {
      backgroundColor: 'transparent',
    },
    '@media screen': {
      backgroundColor: '#F2F2FA',
    },
  },
  interest2: {
    marginBottom: 25,
    '@media print': {
      backgroundColor: 'transparent',
    },
    '@media screen': {
      backgroundColor: '#fcf1f2',
    },
  },
  interest3: {
    '@media print': {
      backgroundColor: 'transparent',
    },
    '@media screen': {
      backgroundColor: '#EBFAF2',
    },
  },
  textSpacer: {
    margin: 0, // Remove custom margin
  },
  rowSpacer: {
    height: 0, // Remove custom height
  },
  textRowSpacer: {
    height: 0, // Remove custom height
  },
  textFieldBackground: {
    backgroundColor: 'white',
  },
  textRowLabelSpacer: {
    height: 0, // Remove custom height
  },
  fieldSpacing: {
    marginBottom: 15, // Consistent vertical space between fields
  },
  [theme.breakpoints.down('xs')]: {
    textField: {
      fontSize: '0.75rem',
    },
    root: {
      '& .MuiFormLabel-root': {
        fontSize: '0.75rem',
      },
    },
  },
  bold: {
    fontWeight: 600,
  },
  subtleBold: {
    fontWeight: 500,
    color: btMediumGrayColor,
  },
  subtleBoldLabel: {
    fontWeight: 500,
    fontSize: '0.95rem',
  },
  textAreaFont: {
    fontSize: '0.938rem',
    fontFamily: 'Source Sans Pro, Helvetica, Roboto, Arial, sans-serif',
    padding: 10,
  },
  printedContent: {
    '@media print': {
      marginBottom: 10,
    },
    '@media screen': {
      display: 'none',
    },
  },
  unprintedContent: {
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
  alignPrintedContent: {
    lineHeight: '25px',
    verticalAlign: 'top',
  },
}));

export default useCareerInterestStyles;
